<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Item List</h4>
                <p class="text-subtitle-1">List of Inventory Items, Services, Non-Inventory Items.</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-1">
            <v-col cols="12" md="3">
                <v-btn block color="primary" @click="handleNew" v-if="hasPermission(p.item.create)" >
                    <v-icon left>mdi-plus</v-icon>
                    new item
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            block
                            depressed
                            @click="searchDialog = !searchDialog"
                            v-on="on"
                            v-bind="attrs">
                            <v-icon left>mdi-magnify</v-icon>
                            search
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>Search</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        label="Code"
                                        :value="params.code"
                                        @input="paramsModel('code', $event)"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        clearable
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        label="Name"
                                        outlined
                                        :value="params.name"
                                        @input="paramsModel('name', $event)"
                                        dense
                                        hide-details="auto"
                                        clearable
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-row no-gutters>
                                <v-col>
                                    <v-btn  block color="primary" @click="submitSearch">
                                        submit
                                    </v-btn>
                                </v-col>
                            </v-row>

                        </v-card-actions>
                    </v-card>
                </v-menu>

            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <ItemList/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ItemList from './../../components/warehouse/ItemList.vue'
import { mapActions, mapGetters, mapState } from 'vuex';
import permissions from './../../data/permissions';

export default {
    name: "ItemListView",
    components: {
        ItemList,
    },
    data() {
        return {
            p: permissions,
            searchDialog: false
        }
    },
    computed: {
        ...mapGetters("authentication", ["hasPermission"]),
        ...mapState("stock/item/list", [
            "params"
        ])
    },
    methods: {
        handleNew() {
            this.$router.push({ name: "ItemCreate"})
        },
        ...mapActions("stock/item/list", [
            "search", "updateParams", "updatePage"
        ]),
        paramsModel(key, value) {
            this.updateParams({key, value})
        },
        submitSearch() {
            this.updatePage(1);
            this.search();
        }
    }
}
</script>

<style>
</style>